import React, { Component } from 'react';
import LinkCreator from './link_creator.jsx';


class LinkCreatorWithDefaults extends Component {

  constructor() {
    super();

    this.getItem = this.getItem.bind(this);
    this.setItem = this.setItem.bind(this);
    this.handleSaveInitialSettings = this.handleSaveInitialSettings.bind(this);
  }

  render() {
    if (!window.localStorage) {
      return <LinkCreator {...this.props} />;
    }

    return (
      <LinkCreator
        initialAskForVisitorInfo={this.getItem('initialAskForVisitorInfo')}
        initialSendNotifications={this.getItem('initialSendNotifications')}
        onInitialSettingsSave={this.handleSaveInitialSettings}
        showShareHelpText={true}
        {...this.props} 
      />
    );
  }

  // Note that localStorage can only save strings so we only treat the string 'true'
  // as the bool `true`, all other string values evaluate as `false`

  getItem(key) {
    return window.localStorage['com.zoomforth.zf.links.createNewLinkDefaults.' + key] === 'true';
  }

  setItem(key, val) {
    window.localStorage.setItem(
      'com.zoomforth.zf.links.createNewLinkDefaults.' + key, val ? 'true' : 'false'
    );
  }

  handleSaveInitialSettings(settings) {
    this.setItem('initialAskForVisitorInfo', !!settings.initialAskForVisitorInfo);
    this.setItem('initialSendNotifications', !!settings.initialSendNotifications);
  }
}

export default LinkCreatorWithDefaults;
